
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class ManageGrowthModule extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/b8aa1437831e5b5f15461ad7f51f246d.png";
  pic2 = "/img/1e53c75d682fc0a28a335b85d5ede889.png";
  pic3 = "/img/66205ee13fb62e4c9f59a99a23a3b548.png";
  pic4 = "/img/ce248a10e13af9e809533dba92e2042e.png";
  pic5 = "/img/cb2997c1c80bb2c03dccacf7aa7046ba.png";
}
